export const reviewsCleaned = [
    {
      "id": 1,
      "date_year_month": "2011-05",
      "count": 2
    },
    {
      "id": 2,
      "date_year_month": "2011-06",
      "count": 2
    },
    {
      "id": 3,
      "date_year_month": "2011-07",
      "count": 3
    },
    {
      "id": 4,
      "date_year_month": "2011-08",
      "count": 4
    },
    {
      "id": 5,
      "date_year_month": "2011-09",
      "count": 4
    },
    {
      "id": 6,
      "date_year_month": "2011-10",
      "count": 3
    },
    {
      "id": 7,
      "date_year_month": "2011-11",
      "count": 3
    },
    {
      "id": 8,
      "date_year_month": "2011-12",
      "count": 2
    },
    {
      "id": 9,
      "date_year_month": "2012-01",
      "count": 7
    },
    {
      "id": 10,
      "date_year_month": "2012-02",
      "count": 5
    },
    {
      "id": 11,
      "date_year_month": "2012-03",
      "count": 10
    },
    {
      "id": 12,
      "date_year_month": "2012-04",
      "count": 11
    },
    {
      "id": 13,
      "date_year_month": "2012-05",
      "count": 11
    },
    {
      "id": 14,
      "date_year_month": "2012-06",
      "count": 13
    },
    {
      "id": 15,
      "date_year_month": "2012-07",
      "count": 22
    },
    {
      "id": 16,
      "date_year_month": "2012-08",
      "count": 21
    },
    {
      "id": 17,
      "date_year_month": "2012-09",
      "count": 16
    },
    {
      "id": 18,
      "date_year_month": "2012-10",
      "count": 18
    },
    {
      "id": 19,
      "date_year_month": "2012-11",
      "count": 22
    },
    {
      "id": 20,
      "date_year_month": "2012-12",
      "count": 13
    },
    {
      "id": 21,
      "date_year_month": "2013-01",
      "count": 30
    },
    {
      "id": 22,
      "date_year_month": "2013-02",
      "count": 23
    },
    {
      "id": 23,
      "date_year_month": "2013-03",
      "count": 28
    },
    {
      "id": 24,
      "date_year_month": "2013-04",
      "count": 28
    },
    {
      "id": 25,
      "date_year_month": "2013-05",
      "count": 29
    },
    {
      "id": 26,
      "date_year_month": "2013-06",
      "count": 28
    },
    {
      "id": 27,
      "date_year_month": "2013-07",
      "count": 36
    },
    {
      "id": 28,
      "date_year_month": "2013-08",
      "count": 41
    },
    {
      "id": 29,
      "date_year_month": "2013-09",
      "count": 36
    },
    {
      "id": 30,
      "date_year_month": "2013-10",
      "count": 40
    },
    {
      "id": 31,
      "date_year_month": "2013-11",
      "count": 29
    },
    {
      "id": 32,
      "date_year_month": "2013-12",
      "count": 40
    },
    {
      "id": 33,
      "date_year_month": "2014-01",
      "count": 47
    },
    {
      "id": 34,
      "date_year_month": "2014-02",
      "count": 49
    },
    {
      "id": 35,
      "date_year_month": "2014-03",
      "count": 61
    },
    {
      "id": 36,
      "date_year_month": "2014-04",
      "count": 61
    },
    {
      "id": 37,
      "date_year_month": "2014-05",
      "count": 58
    },
    {
      "id": 38,
      "date_year_month": "2014-06",
      "count": 74
    },
    {
      "id": 39,
      "date_year_month": "2014-07",
      "count": 94
    },
    {
      "id": 40,
      "date_year_month": "2014-08",
      "count": 134
    },
    {
      "id": 41,
      "date_year_month": "2014-09",
      "count": 131
    },
    {
      "id": 42,
      "date_year_month": "2014-10",
      "count": 144
    },
    {
      "id": 43,
      "date_year_month": "2014-11",
      "count": 154
    },
    {
      "id": 44,
      "date_year_month": "2014-12",
      "count": 194
    },
    {
      "id": 45,
      "date_year_month": "2015-01",
      "count": 221
    },
    {
      "id": 46,
      "date_year_month": "2015-02",
      "count": 183
    },
    {
      "id": 47,
      "date_year_month": "2015-03",
      "count": 226
    },
    {
      "id": 48,
      "date_year_month": "2015-04",
      "count": 229
    },
    {
      "id": 49,
      "date_year_month": "2015-05",
      "count": 317
    },
    {
      "id": 50,
      "date_year_month": "2015-06",
      "count": 370
    },
    {
      "id": 51,
      "date_year_month": "2015-07",
      "count": 464
    },
    {
      "id": 52,
      "date_year_month": "2015-08",
      "count": 589
    },
    {
      "id": 53,
      "date_year_month": "2015-09",
      "count": 571
    },
    {
      "id": 54,
      "date_year_month": "2015-10",
      "count": 501
    },
    {
      "id": 55,
      "date_year_month": "2015-11",
      "count": 482
    },
    {
      "id": 56,
      "date_year_month": "2015-12",
      "count": 589
    },
    {
      "id": 57,
      "date_year_month": "2016-01",
      "count": 692
    },
    {
      "id": 58,
      "date_year_month": "2016-02",
      "count": 656
    },
    {
      "id": 59,
      "date_year_month": "2016-03",
      "count": 596
    },
    {
      "id": 60,
      "date_year_month": "2016-04",
      "count": 725
    },
    {
      "id": 61,
      "date_year_month": "2016-05",
      "count": 787
    },
    {
      "id": 62,
      "date_year_month": "2016-06",
      "count": 804
    },
    {
      "id": 63,
      "date_year_month": "2016-07",
      "count": 1056
    },
    {
      "id": 64,
      "date_year_month": "2016-08",
      "count": 1052
    },
    {
      "id": 65,
      "date_year_month": "2016-09",
      "count": 956
    },
    {
      "id": 66,
      "date_year_month": "2016-10",
      "count": 935
    },
    {
      "id": 67,
      "date_year_month": "2016-11",
      "count": 852
    },
    {
      "id": 68,
      "date_year_month": "2016-12",
      "count": 1095
    },
    {
      "id": 69,
      "date_year_month": "2017-01",
      "count": 1333
    },
    {
      "id": 70,
      "date_year_month": "2017-02",
      "count": 1210
    },
    {
      "id": 71,
      "date_year_month": "2017-03",
      "count": 1254
    },
    {
      "id": 72,
      "date_year_month": "2017-04",
      "count": 1384
    },
    {
      "id": 73,
      "date_year_month": "2017-05",
      "count": 1305
    },
    {
      "id": 74,
      "date_year_month": "2017-06",
      "count": 1325
    },
    {
      "id": 75,
      "date_year_month": "2017-07",
      "count": 1835
    },
    {
      "id": 76,
      "date_year_month": "2017-08",
      "count": 1860
    },
    {
      "id": 77,
      "date_year_month": "2017-09",
      "count": 1672
    },
    {
      "id": 78,
      "date_year_month": "2017-10",
      "count": 1637
    },
    {
      "id": 79,
      "date_year_month": "2017-11",
      "count": 1389
    },
    {
      "id": 80,
      "date_year_month": "2017-12",
      "count": 1647
    },
    {
      "id": 81,
      "date_year_month": "2018-01",
      "count": 1865
    },
    {
      "id": 82,
      "date_year_month": "2018-02",
      "count": 1648
    },
    {
      "id": 83,
      "date_year_month": "2018-03",
      "count": 1782
    },
    {
      "id": 84,
      "date_year_month": "2018-04",
      "count": 1875
    },
    {
      "id": 85,
      "date_year_month": "2018-05",
      "count": 1860
    },
    {
      "id": 86,
      "date_year_month": "2018-06",
      "count": 1908
    },
    {
      "id": 87,
      "date_year_month": "2018-07",
      "count": 2496
    },
    {
      "id": 88,
      "date_year_month": "2018-08",
      "count": 2433
    },
    {
      "id": 89,
      "date_year_month": "2018-09",
      "count": 2320
    },
    {
      "id": 90,
      "date_year_month": "2018-10",
      "count": 2262
    },
    {
      "id": 91,
      "date_year_month": "2018-11",
      "count": 2145
    },
    {
      "id": 92,
      "date_year_month": "2018-12",
      "count": 2406
    },
    {
      "id": 93,
      "date_year_month": "2019-01",
      "count": 2827
    },
    {
      "id": 94,
      "date_year_month": "2019-02",
      "count": 2530
    },
    {
      "id": 95,
      "date_year_month": "2019-03",
      "count": 2634
    },
    {
      "id": 96,
      "date_year_month": "2019-04",
      "count": 2753
    },
    {
      "id": 97,
      "date_year_month": "2019-05",
      "count": 2828
    },
    {
      "id": 98,
      "date_year_month": "2019-06",
      "count": 2981
    },
    {
      "id": 99,
      "date_year_month": "2019-07",
      "count": 3632
    },
    {
      "id": 100,
      "date_year_month": "2019-08",
      "count": 3849
    },
    {
      "id": 101,
      "date_year_month": "2019-09",
      "count": 3829
    },
    {
      "id": 102,
      "date_year_month": "2019-10",
      "count": 3517
    },
    {
      "id": 103,
      "date_year_month": "2019-11",
      "count": 3536
    },
    {
      "id": 104,
      "date_year_month": "2019-12",
      "count": 3801
    },
    {
      "id": 105,
      "date_year_month": "2020-01",
      "count": 4290
    },
    {
      "id": 106,
      "date_year_month": "2020-02",
      "count": 2928
    },
    {
      "id": 107,
      "date_year_month": "2020-03",
      "count": 901
    }
  ]